import { render, staticRenderFns } from "./modalRol.vue?vue&type=template&id=225ab8ac"
import script from "./modalRol.vue?vue&type=script&lang=js"
export * from "./modalRol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports